// src/components/ContentViews/ExploreView.js
import React, { useEffect } from 'react';
import StarterPanel from './StarterPanel';
import ResultsDisplay from './ResultsDisplay';
import NewQuestionButton from './NewQuestionButton';
import useExploreStore from '../../contexts/useExploreStore';

const ExploreView = () => {
  const { showStarterPanel, currentQuery, setResults } = useExploreStore();

  useEffect(() => {
    // Trigger API call when currentQuery changes
    const fetchResults = async () => {
      if (currentQuery) {
        try {
          const response = await fetch(
            `https://api.example.com/search?q=${encodeURIComponent(currentQuery)}`
          );

          if (!response.ok) {
            throw new Error('Network response was not ok');
          }

          const data = await response.json();
          setResults(data.results);
        } catch (error) {
          console.error("Failed to fetch results:", error);
          setResults([]); // Clear results to indicate error
        }
      }
    };
    fetchResults();
  }, [currentQuery, setResults]);

  return (
    <div className="p-4 flex flex-col h-full">
      {showStarterPanel ? <StarterPanel /> : <ResultsDisplay />}
      <div className="mt-auto"> {/* Ensures the button is pushed to the bottom */}
        <NewQuestionButton />
      </div>
    </div>
  );
};

export default ExploreView;
